import { HeroProps } from 'src/components/Hero/types'
import { useTranslation } from 'react-i18next'

import useHero, { UseHeroProps } from './useHero'

const useHeroWithTag = ({
  type,
  tag,
  ...props
}: UseHeroProps & { type?: string; tag?: string }): HeroProps => {
  const { t } = useTranslation()
  const hero = useHero(props)

  return {
    ...(type && {
      roundedTagProps: {
        text: t(`hero.tag.${type}`),
      },
    }),
    ...(tag && {
      roundedTagProps: {
        text: tag,
      },
    }),
    ...hero,
  }
}

export default useHeroWithTag
